import React from "react";
import RestService from "../../services/api/RestService";
import { useSnackbar } from "notistack";
import { FeedbackForm } from "../../components/Feedback/FeedbackForm";
import { FeedbackItem } from "../../data/FeedbackItem";
import { success } from "../../utils/SnackbarVariants";
import { makeStyles } from 'tss-react/mui';
import { Typography } from "@mui/material";
import {useTranslation} from "react-i18next";
import useTypedParams from "../../hooks/UseTypedParams";
import {useNavigate} from "react-router-dom";

const useStyles = makeStyles()({
    description: {
        marginBottom: "20px",
        marginTop: "20px",
    },
});

interface FeedbackPageParams {
    [securityCode: string]: string
}

export default function FeedbackPage() {
    const { classes } = useStyles();
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const { securityCode } = useTypedParams<FeedbackPageParams>();
    const navigate = useNavigate()
    function saveFeedback(feedbackItems: FeedbackItem[]) {
        RestService.saveFeedback(securityCode, feedbackItems).then(
            (_) => {
                enqueueSnackbar(
                    t("feedbackPage:snackbarAfterSendingFeedback"),
                    success
                );
                navigate(`/summary`);
            }
        );
    }

    return (
        <>
            <Typography variant="h3" gutterBottom={true}>
                {t("feedbackPage:addFeedback")}
            </Typography>
            <Typography variant="body1" className={classes.description}>
                {t("feedbackPage:description")}
            </Typography>
            <FeedbackForm onAdd={saveFeedback} />
        </>
    );
}
